import {EXPLORE_CAMERA_ANGLE} from './HomepageAssets/ExploreRemotion/camera-angle';
import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	interpolate,
	useCurrentFrame,
} from 'remotion';

export const AudioWaveformPreview = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			style={{
				width: 2560,
				height: 1402,
				translate: '-203px -403.5px',
				rotate: EXPLORE_CAMERA_ANGLE,
				scale: 1.298,
			}}
			from={-207}
		>
			<Video
				src="https://remotion.media/explore-remotion/audio-waveform-source-2026-09-21.mp4"
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={'auto'}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[-207, -127, -120, 225, 230],
						[
							6.069946650859514, 5.462951985773563, 6.069946650859514,
							5.462951985773563, 6.069946650859514,
						],
						{
							easing: [Easing.step1, Easing.step1, Easing.step1, Easing.step1],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							-192, -191, -190, -189, -188, -184, -183, -182, -181, -180, -179,
							-178, -177, -176, -175, -174, -173, -172, -171, -170, -169, -168,
							-167, -166, -165, -164, -163, -162, -161, -160, -159, -158, -157,
							-156, -155, -154, -153, -152, -151, -150, -149, -148, -147, -146,
							-145, -144, -143, -142, -141, -93, -92, -91, -90, -89, -88, -87,
							-86, -85, -84, -83, -39, -38, -37, -36, -35, -34, -33, -32, -31,
							-30, -29, -28, -27, -26, 189, 190, 191, 192, 193, 194, 195, 196,
							197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209,
							210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222,
						],
						[
							'1813.6336692353289px 1081.6834617664492px',
							'1804.9081209247183px 1081.6834617664492px',
							'1796.1825726141078px 1081.6834617664492px',
							'1796.1825726141078px 1081.6834617664492px',
							'1792.3414344991108px 1081.6834617664492px',
							'1792.3414344991108px 1081.6834617664492px',
							'1790.800237107291px 1081.6834617664492px',
							'1790.800237107291px 1086.2833432128039px',
							'1785.2756372258445px 1094.9614700652044px',
							'1782.9519857735625px 1103.639596917605px',
							'1782.9519857735625px 1103.639596917605px',
							'1779.7510373443984px 1112.3177237700058px',
							'1775.103734439834px 1116.9176052163605px',
							'1772.7800829875519px 1123.817427385892px',
							'1770.4564315352695px 1128.4173088322466px',
							'1765.8091286307053px 1133.017190278601px',
							'1761.161825726141px 1137.6170717249554px',
							'1756.5145228215767px 1139.9170124481327px',
							'1747.7889745109662px 1145.3941908713693px',
							'1739.0634262003555px 1148.5714285714284px',
							'1726.2596324836989px 1148.5714285714284px',
							'1707.6704208654414px 1148.5714285714284px',
							'1680.6639004149376px 1133.7522228808537px',
							'1632.3414344991108px 1092.116182572614px',
							'1579.5850622406638px 1039.3598103141671px',
							'1535.3171310017783px 982.5726141078837px',
							'1491.0491997628926px 925.7854179016005px',
							'1450.3141671606402px 879.2175459395376px',
							'1409.5791345583875px 838.4825133372851px',
							'1375.0088915234144px 813.7759336099584px',
							'1343.070539419087px 795.7557794902193px',
							'1324.4813278008298px 788.4765856550089px',
							'1305.8921161825726px 781.1973918197984px',
							'1280.901007705987px 781.1973918197984px',
							'1262.3117960877296px 781.1973918197984px',
							'1243.7225844694724px 781.1973918197984px',
							'1225.1333728512152px 781.1973918197984px',
							'1212.3295791345583px 781.1973918197984px',
							'1199.5257854179015px 784.3746295198576px',
							'1190.800237107291px 787.551867219917px',
							'1186.1529342027268px 792.1517486662715px',
							'1180.6283343212804px 800.8298755186721px',
							'1174.226437462952px 813.5862477771191px',
							'1171.0254890337878px 826.342620035566px',
							'1167.8245406046235px 835.0207468879668px',
							'1167.8245406046235px 847.7771191464137px',
							'1167.8245406046235px 852.3770005927682px',
							'1167.8245406046235px 856.9768820391226px',
							'1167.8245406046235px 858.8737403675162px',
							'1167.8245406046235px 858.8737403675162px',
							'1171.570835803201px 856.5500889152341px',
							'1176.1707172495553px 856.5500889152341px',
							'1178.4706579727326px 856.5500889152341px',
							'1180.3675163011262px 854.6295198577355px',
							'1184.5643153526971px 854.6295198577355px',
							'1189.1641967990515px 852.3058684054535px',
							'1189.1641967990515px 852.3058684054535px',
							'1193.3609958506224px 849.9822169531712px',
							'1219.4665085951392px 849.9822169531712px',
							'1248.5358624777712px 849.9822169531712px',
							'1248.5358624777712px 849.9822169531712px',
							'1247.065797273266px 849.9822169531712px',
							'1242.4184943687019px 849.9822169531712px',
							'1242.4184943687019px 849.9822169531712px',
							'1238.1742738589212px 849.9822169531712px',
							'1236.2537048014226px 849.9822169531712px',
							'1234.333135743924px 849.9822169531712px',
							'1230.0889152341433px 849.9822169531712px',
							'1225.4416123295791px 849.9822169531712px',
							'1220.7943094250147px 849.9822169531712px',
							'1216.1470065204505px 849.9822169531712px',
							'1216.1470065204505px 849.9822169531712px',
							'1214.226437462952px 849.9822169531712px',
							'1212.471843509188px 849.9822169531712px',
							'1212.471843509188px 849.9822169531712px',
							'1238.6484884410195px 871.7960877296977px',
							'1253.4439834024895px 886.5915826911677px',
							'1306.65085951393px 923.248369887374px',
							'1326.3781861292234px 933.1120331950207px',
							'1388.9270895080024px 977.3325429756965px',
							'1435.4475400118554px 1012.1873147599289px',
							'1461.5530527563722px 1028.429164196799px',
							'1480.0948429164196px 1038.8618850029638px',
							'1498.636633076467px 1046.0936573799645px',
							'1511.393005334914px 1055.6490812092472px',
							'1530.5275637225843px 1065.180794309425px',
							'1543.2839359810314px 1071.5352697095436px',
							'1551.9620628334321px 1073.8352104327207px',
							'1560.6401896858329px 1077.01244813278px',
							'1573.3965619442797px 1080.1896858328394px',
							'1577.996443390634px 1082.4896265560164px',
							'1582.5963248369887px 1082.4896265560164px',
							'1587.1962062833431px 1082.4896265560164px',
							'1587.1962062833431px 1082.4896265560164px',
							'1588.8559573206876px 1082.4896265560164px',
							'1590.5868405453466px 1082.4896265560164px',
							'1595.1867219917012px 1082.4896265560164px',
							'1599.7866034380556px 1082.4896265560164px',
							'1604.38648488441px 1082.4896265560164px',
							'1608.9863663307647px 1077.8423236514523px',
							'1613.586247777119px 1075.5186721991702px',
							'1622.2643746295198px 1069.9940723177237px',
							'1635.0207468879667px 1066.7931238885594px',
							'1643.6988737403674px 1063.5921754593953px',
							'1652.3770005927681px 1061.2685240071132px',
							'1654.6769413159454px 1061.2685240071132px',
							'1659.2768227622998px 1061.2685240071132px',
							'1661.1499703615887px 1061.2685240071132px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

export const AudioWaveform = () => {
	return (
		<Composition
			id={'AudioWaveform'}
			component={AudioWaveformPreview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={200}
		/>
	);
};
